import { PostPurchaseSplitStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { FlowInProgress } from "@redotech/redo-flows-common/flow-in-progress";
import { FrontendStepType, PartialFlowStep, PartialWithRequiredType } from "..";
import { PostPurchaseSplitEditInspector } from "./edit-inspector";
import { PostPurchaseSplitViewInspector } from "./view-inspector";

function PostPurchaseSplitInspector({
  step,
  setStep,
  onClose,
  setAutomation,
  readonly = false,
  steps,
}: {
  step: PartialWithRequiredType<PostPurchaseSplitStep>;
  steps: PartialFlowStep[];
  setStep: (step: PartialWithRequiredType<PostPurchaseSplitStep>) => void;
  onClose?: () => void;
  setAutomation?: React.Dispatch<React.SetStateAction<FlowInProgress | null>>;
  readonly?: boolean;
}) {
  if (readonly) {
    return <PostPurchaseSplitViewInspector onClose={onClose} step={step} />;
  } else {
    return (
      <PostPurchaseSplitEditInspector
        onClose={onClose}
        setAutomation={setAutomation}
        setStep={setStep}
        step={step}
        steps={steps}
      />
    );
  }
}

export const postPurchaseSplitStepType: FrontendStepType<
  PartialWithRequiredType<PostPurchaseSplitStep>
> = {
  type: "custom",
  valid: (step) =>
    !!step.splitId &&
    !!step.name &&
    !!(step.treatments && step.treatments.length >= 2) &&
    step.treatments.every(
      (treatment) =>
        !!treatment.treatmentId &&
        !!treatment.name &&
        !!treatment.weight &&
        !!treatment.nextId,
    ),
  selectable: (_) => true,
  customInspector: (args) => {
    return PostPurchaseSplitInspector({
      step: args.step,
      setStep: args.setStep,
      onClose: args.onClose,
      setAutomation: args.setAutomation,
      readonly: args.readonly,
      steps: args.steps,
    });
  },
};
